'use client';

import { useEffect, useState } from 'react';
import ru from '@/i18n/common/ru.json';
import { captureClientError } from '@/lib/observability/client-error-reporter';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [eventId] = useState(() => crypto.randomUUID());
  useEffect(() => {
    captureClientError(error, { eventId, title: 'Global React render error', errorCode: error.digest ?? 'GLOBAL_REACT_ERROR' });
  }, [error, eventId]);
  const copy = ru.observability;
  return (
    <html lang="ru">
      <body>
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
          <section style={{ maxWidth: 420, textAlign: 'center' }}>
            <h1>{copy.crash_title}</h1>
            <p>{copy.crash_body}</p>
            <p>{copy.error_code.replace('{{code}}', eventId.slice(0, 8).toUpperCase())}</p>
            <button onClick={reset}>{copy.retry}</button>
            <button onClick={() => (window.Telegram?.WebApp as unknown as { close?: () => void } | undefined)?.close?.()}>{copy.close}</button>
          </section>
        </main>
      </body>
    </html>
  );
}
